import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createOverdueReportApi(params: any) {
    let apiData: any = {
        saveReport: params.saveReport
    };
    let backendApiUrl = `${config.BACKEND_BASE_URL}/report/overdue-report`;
    return api.create(`${backendApiUrl}`, apiData);
}

export { createOverdueReportApi };